import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ConditionEditorContext, ConditionEditorContextConsumer, ConditionEntry } from '@sdbn/common-extended';
import { Subject } from 'rxjs';
import { TransportStatus } from '../../../common/model/transport.model';

@Component({
  selector: 'yard-transport-status-condition-editor',
  standalone: false,
  templateUrl: './transport-status-condition-editor.component.html',
  styleUrl: './transport-status-condition-editor.component.scss',
})
export class TransportStatusConditionEditorComponent implements OnInit, ConditionEditorContextConsumer {

  condition: ConditionEntry;

  TransportStatus = TransportStatus;

  formGroup: FormGroup;

  setConditionEditorContext(context: ConditionEditorContext): void {
    context.selectedCondition.subscribe(
      condition => {
        this.condition = condition;
        this.formGroup.patchValue({ value: condition.data });
      }
    );
  }

  setChangedSubject(changed: Subject<void>): void {
  }

  ngOnInit(): void {

    let assigned: string[] = this.condition.data ? this.condition.data.split(',') : [];
    let formGroup = new FormGroup({});
    for (let item in TransportStatus) {
      formGroup.addControl(item, new FormControl(assigned.includes(item), []));
    }
    this.formGroup = formGroup;

    this.formGroup.valueChanges.subscribe(value => {

      let data = '';
      for (let item in TransportStatus) {
        if (value[item]) {
          if (data != '') {
            data += ',';
          }
          data += item;
        }
      }
      this.condition.data = data;

    });
  }

}
